export const FETCH_COUNTRY_LIST = "fetchCountryList";
